import { Component, OnInit, input, output } from '@angular/core';
import { Task } from 'src/app/models/tasks';
import { NgClass } from '@angular/common';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { Bind } from 'primeng/bind';
import { ButtonDirective } from 'primeng/button';

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-task-details',
    templateUrl: './task-details.component.html',
    styleUrls: ['./task-details.component.scss'],
    imports: [TPipe, CdkDrag, NgClass, Bind, ButtonDirective]
})
export class TaskDetailsComponent {
  readonly tasks = input<Task[]>(undefined);
  readonly borderColor = input<String>(undefined);
  readonly deleteItem = output<any>();
  readonly editItem = output<any>();
  readonly viewItem = output<any>();
  readonly getEmployeeItem = output<any>();

  readonly edit = input<boolean>(true);
  readonly cancel = input<boolean>(true);

  deleteTask(id, title, type, index) {
    this.deleteItem.emit({id, title, type, index});
  }

  editTask(task) {
    this.editItem.emit(task);
  }

  viewTask(task) {
    this.viewItem.emit(task);
  }

  getCategoryItem(task) {
    this.getEmployeeItem.emit(task.employee_id);
  }

}
